"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.Strong = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Strong = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(kaleidoscope_1.Text, { className: "tour-strong", strong: true, theme: "dark", size: "s" }, children));
};
exports.Strong = Strong;
var Link = function (_a) {
    var href = _a.href, children = _a.children;
    return (react_1.default.createElement(kaleidoscope_1.Link, { className: "tour-link", href: href, theme: kaleidoscope_2.LinkTheme.Dark }, children));
};
exports.Link = Link;
